var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-episode"},[_c('episode-form',{attrs:{"is-voice":_vm.article.content_model === 'voice',"action":"edit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }